import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchUpdateManualResource = async (
  projectId,
  manualResourceId,
  updateAttributes
) => {
  const apiPath = `projects/${projectId}/manual-resource/${manualResourceId}/update-manual-resource`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: updateAttributes,
  });

  const response = await axios(signedRequest);

  return response.data;
};
